import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DxChartComponent, DxPivotGridComponent } from 'devextreme-angular';
import { exportPivotGrid } from 'devextreme/excel_exporter';
import { exportWidgets } from 'devextreme/viz/export';
import { Workbook } from 'exceljs';
import { O2PortalHycoReportService } from 'src/app/reports/o2-reports/o2-portal-hyco-report/service/o2-portal-hyco-report-service';
import saveAs from 'file-saver';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
@Component({
  selector: 'app-o2-portal-hyco-oneyr-analysis-report',
  templateUrl: './o2-portal-hyco-oneyr-analysis-report.component.html',
  styleUrls: ['./o2-portal-hyco-oneyr-analysis-report.component.scss']
})
export class O2PortalHycoOneyrAnalysisReportComponent implements OnInit {

  @Input() currentYearMonthsInfo: any;
  @Input() selectedAnnouncementYear: number;
  @Input() selectedReportLinkId: number;
  consolidatedSOGAnnouncementYearDataSource: any;
  cyTonnageBusinessCapitalDataSource: any;
  pyTonnageBusinessCapitalDataSource: any;

  cyASUCapitalDataSource: any;
  pyASUCapitalDataSource: any;

  cyHyCOCapitalDataSource: any;
  pyHyCOCapitalDataSource: any;

  barChartSeriesColors: Map<string, string>;
  cyTBCBillionUSDCapital: string;
  pyTBCBillionUSDCapital: string;
  cyASUCBillionUSDCapital: string;
  pyASUCBillionUSDCapital: string;
  cyHyCOCBillionUSDCapital: string;
  pyHyCOCBillionUSDCapital: string;

  cyPivotGridDataSource: any;
  pyPivotGridDataSource: any;
  @ViewChild("currentYearTonnageBusinessCapitalReportChart", { static: false }) dxCYTBCBarChart: DxChartComponent;
  @ViewChild("previousYearTonnageBusinessCapitalReportChart", { static: false }) dxPYTBCBarChart: DxChartComponent;
  @ViewChild("currentYearAnalysisASUReportChart", { static: false }) dxCYASUCBarChart: DxChartComponent;
  @ViewChild("previousYearAnalysisASUReportChart", { static: false }) dxPYASUCBarChart: DxChartComponent;
  @ViewChild("currentYearAnalysisHyCoReportChart", { static: false }) dxCYHYCOCBarChart: DxChartComponent;
  @ViewChild("previousYearAnalysisHyCoReportChart", { static: false }) dxPYHYCOCBarChart: DxChartComponent;
  @ViewChild('cyPivotGrid', { static: false }) dxCYPivotGrid: DxPivotGridComponent;
  @ViewChild('pyPivotGrid', { static: false }) dxPYPivotGrid: DxPivotGridComponent;

  constructor(private notificationService: NotificationService, private o2PortalHycoReportService: O2PortalHycoReportService) {
  }

  ngOnInit(): void {
    this.getHyCoAnalysisReportData(this.selectedReportLinkId, this.selectedAnnouncementYear);
    this.barChartSeriesColors = new Map<string, string>();
  }

  getHyCoAnalysisReportData(_selectedReportLinkId: number, _selectedAnnouncementYear: number) {
    this.o2PortalHycoReportService.getHyCoAnalysisReportData(_selectedReportLinkId, _selectedAnnouncementYear).subscribe({
      next: data => {
        this.consolidatedSOGAnnouncementYearDataSource = data;
        this.barChartSeriesColors.clear();
        this.setDataSource();
      },
      error: (error: any) => {
        this.notificationService.alert("error", "Error while fetching HyCoAnalysis Report data", error);
      }
    });
  }

  setDataSource() {
    // sort result by compititor
    let goNoOfYearBack = 1;
    if (this.selectedReportLinkId == 2) {
      goNoOfYearBack = 5;
    }

    // CURRENT Year  - Tonnage Business Data Calculation
    let currentYearData = this.consolidatedSOGAnnouncementYearDataSource.filter(x => x.announcementYear == this.selectedAnnouncementYear);
    currentYearData.sort((a, b) => { return a.competitor.localeCompare(b.competitor) });
    let capitalTotalInMillion = 0.0;
    this.cyTonnageBusinessCapitalDataSource = JSON.parse(JSON.stringify(currentYearData))
    this.cyTonnageBusinessCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });

    this.cyTBCBillionUSDCapital = (capitalTotalInMillion / 1000).toFixed(2) + " Billion USD";
    this.cyTonnageBusinessCapitalDataSource = this.cyTonnageBusinessCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.businessType == item.businessType);
      if (accItem) {
        accItem.competitorInvestment = Math.round(accItem.competitorInvestment + item.competitorInvestment);
      } else {
        accm.push(item);
      }

      return accm;
    }, []);
    // PREVIOUS Year  - Tonnage Business Data Calculation
    let previousYearData = this.consolidatedSOGAnnouncementYearDataSource.filter(x => x.announcementYear == (this.selectedAnnouncementYear - 1));
    previousYearData.sort((a, b) => { return a.competitor.localeCompare(b.competitor) });
    capitalTotalInMillion = 0.0;
    this.pyTonnageBusinessCapitalDataSource = JSON.parse(JSON.stringify(previousYearData));
    this.pyTonnageBusinessCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });
    this.pyTBCBillionUSDCapital = (capitalTotalInMillion / 1000).toFixed(2) + " Billion USD";

    this.pyTonnageBusinessCapitalDataSource = this.pyTonnageBusinessCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.businessType == item.businessType);
      if (accItem) {
        accItem.competitorInvestment = Math.round(accItem.competitorInvestment + item.competitorInvestment);
      } else {
        accm.push(item);
      }
      return accm;
    }, []);

    // CURRENT Year  - ASU Capital Data Calculation
    let currentYearASUData = currentYearData.filter(x => x.offeringType == 'ASU');
    currentYearASUData.sort((a, b) => { return a.competitor.localeCompare(b.competitor) });
    capitalTotalInMillion = 0.0;
    this.cyASUCapitalDataSource = JSON.parse(JSON.stringify(currentYearASUData));
    this.cyASUCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });

    this.cyASUCBillionUSDCapital = (capitalTotalInMillion / 1000).toFixed(2) + " Billion USD";
    this.cyASUCapitalDataSource = this.cyASUCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.businessType == item.businessType);
      if (accItem) {
        accItem.competitorInvestment = Math.round(accItem.competitorInvestment + item.competitorInvestment);
      } else {
        accm.push(item);
      }

      return accm;
    }, []);

    // PREVIOUS Year  - ASU Data Calculation
    let previousYearASUData = previousYearData.filter(x => x.offeringType == 'ASU');
    previousYearASUData.sort((a, b) => { return a.competitor.localeCompare(b.competitor) });
    this.pyASUCapitalDataSource = JSON.parse(JSON.stringify(previousYearASUData));
    capitalTotalInMillion = 0.0;
    this.pyASUCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });

    this.pyASUCBillionUSDCapital = (capitalTotalInMillion / 1000).toFixed(2) + " Billion USD";
    this.pyASUCapitalDataSource = this.pyASUCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.businessType == item.businessType);
      if (accItem) {
        accItem.competitorInvestment = Math.round(accItem.competitorInvestment + item.competitorInvestment);
      } else {
        accm.push(item);
      }

      return accm;
    }, []);


    // CURRENT Year  - HyCO Capital Data Calculation
    let currentYearHyCOData = currentYearData.filter(x => x.offeringType == 'HyCO');
    currentYearHyCOData.sort((a, b) => { return a.competitor.localeCompare(b.competitor) });
    capitalTotalInMillion = 0.0;
    this.cyHyCOCapitalDataSource = JSON.parse(JSON.stringify(currentYearHyCOData));
    this.cyHyCOCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });

    this.cyHyCOCBillionUSDCapital = (capitalTotalInMillion / 1000).toFixed(2) + " Billion USD";
    this.cyHyCOCapitalDataSource = this.cyHyCOCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.businessType == item.businessType);
      if (accItem) {
        accItem.competitorInvestment = Math.round(accItem.competitorInvestment + item.competitorInvestment);
      } else {
        accm.push(item);
      }

      return accm;
    }, []);

    // PREVIOUS Year  - HyCO Data Calculation
    let previousYearHyCOData = previousYearData.filter(x => x.offeringType == 'HyCO');
    previousYearHyCOData.sort((a, b) => { return a.competitor.localeCompare(b.competitor) });
    capitalTotalInMillion = 0.0;
    this.pyHyCOCapitalDataSource = JSON.parse(JSON.stringify(previousYearHyCOData));
    this.pyHyCOCapitalDataSource.map(item => {
      capitalTotalInMillion = capitalTotalInMillion + item.competitorInvestment;
      return item;
    });

    this.pyHyCOCBillionUSDCapital = (capitalTotalInMillion / 1000).toFixed(2) + " Billion USD";
    this.pyHyCOCapitalDataSource = this.pyHyCOCapitalDataSource.reduce((accm, item) => {
      let accItem = accm.find(ai => ai.competitor == item.competitor && ai.businessType == item.businessType);
      if (accItem) {
        accItem.competitorInvestment = Math.round(accItem.competitorInvestment + item.competitorInvestment);
      } else {
        accm.push(item);
      }

      return accm;
    }, []);

    this.cyPivotGridDataSource = {
      fields: [{
        caption: 'Investment USD $MM',
        width: 120,
        dataField: 'businessType',
        area: 'row',
      }, {
        dataField: 'competitor',
        area: 'column',
      }, {
        groupName: 'businessType',
        visible: false,
      }, {
        caption: 'Total',
        dataField: 'competitorInvestment',
        dataType: 'number',
        summaryType: 'sum',
        area: 'data',
        format: {
          precision: Number
        }
      }],
      store: currentYearData
    }

    this.pyPivotGridDataSource = {
      fields: [{
        caption: 'Investment USD $MM',
        width: 120,
        dataField: 'businessType',
        area: 'row',
      }, {
        dataField: 'competitor',
        area: 'column',
      }, {
        groupName: 'businessType',
        visible: false,
      }, {
        caption: 'Total',
        dataField: 'competitorInvestment',
        dataType: 'number',
        summaryType: 'sum',
        area: 'data',
        format: {
          precision: Number
        }
      }],
      store: previousYearData
    }

  }

  customizeTooltip(arg: any) {
    return {
      text: `${arg.seriesName} : ${arg.valueText}` + ' USD $MM',
    };
  }

  exportCharts() {

    const dxCYTBCBarChartInstance = this.dxCYTBCBarChart.instance;
    const dxPYTBCBarChartInstance = this.dxPYTBCBarChart.instance;
    const dxCYASUCBarChartInstance = this.dxCYASUCBarChart.instance;
    const dxPYASUCBarChartInstance = this.dxPYASUCBarChart.instance;
    const dxCYHYCOCBarChartInstance = this.dxCYHYCOCBarChart.instance;
    const dxPYHYCOCBarChartInstance = this.dxPYHYCOCBarChart.instance;

    exportWidgets([[dxCYTBCBarChartInstance, dxPYTBCBarChartInstance],
    [dxCYASUCBarChartInstance, dxPYASUCBarChartInstance],
    [dxCYHYCOCBarChartInstance, dxPYHYCOCBarChartInstance]], {
      fileName: "AnnouncedASUHyCOAwards_SOG_Summary",
      format: "PNG"
    });
  }
  exportExcel(e) {
    const context = this;
    const workbook = new Workbook();
    const cyWorkSheet = workbook.addWorksheet("CurrentYear Competitor Investment");
    const pyWorkSheet = workbook.addWorksheet("PreviousYear Competitor Investment");

    exportPivotGrid({
      worksheet: cyWorkSheet,
      component: context.dxCYPivotGrid.instance
    }).then(() => {
      exportPivotGrid({
        worksheet: pyWorkSheet,
        component: context.dxPYPivotGrid.instance
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AnnouncedASUHyCOAwards_SOG_Summary.xlsx');
        })
      })
    });
  }

  onCellPrepared(e) {
    if (e.area === "data" && e.cell.text === "") {
      e.cellElement.textContent = "0";
    }
  }

  customizePoint = (arg: any) => {
    if (!this.barChartSeriesColors.has(arg.data.businessType)) {
      this.barChartSeriesColors.set(arg.data.businessType, arg.series.pointsByArgument[arg.argument][0].getColor());
    }
    return { color: this.barChartSeriesColors.get(arg.data.businessType), hoverStyle: { color: this.barChartSeriesColors.get(arg.data.businessType) } };
  }
}
